import { Menu } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from "components/Sheet";

const routes = [
  { label: "3DExcite", href: "/3dexcite" },
  { label: "Reel", href: "/demo-reel" },
  { label: "Archive", href: "/other-works" },
  { label: "About", href: "/about" },
];

export const Header = () => {
  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[#090b0f]/90 backdrop-blur-xl">
      <div className="page-shell flex h-[82px] items-center justify-between">
        <Link
          to="/"
          className="group flex items-center gap-3"
          aria-label="Home"
        >
          <span className="grid h-10 w-10 place-items-center border border-white/20 text-sm font-bold tracking-[-0.04em] transition group-hover:border-ember group-hover:bg-ember">
            GK
          </span>
          <span>
            <span className="block text-sm font-semibold tracking-[-0.01em]">
              Gregory Kalamdaryan
            </span>
            <span className="mt-0.5 block text-[10px] font-semibold uppercase tracking-[0.2em] text-white/40">
              Visual Effects Artist
            </span>
          </span>
        </Link>

        <nav
          className="hidden items-center gap-9 md:flex"
          aria-label="Primary navigation"
        >
          {routes.map((route) => (
            <NavLink
              key={route.href}
              to={route.href}
              className={({ isActive }) =>
                `nav-link ${isActive ? "nav-link-active" : ""}`
              }
            >
              {route.label}
            </NavLink>
          ))}
          <a
            className="button-primary !h-10 !px-5"
            href="mailto:gregk2013@gmail.com"
          >
            Get in touch
          </a>
        </nav>

        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <button
                type="button"
                className="grid h-11 w-11 place-items-center border border-white/20 text-white transition hover:border-ember"
                aria-label="Open navigation"
              >
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent className="dark border-l border-white/10 bg-[#090b0f] px-8 py-10">
              <p className="eyebrow mb-12">Navigation</p>
              <nav className="flex flex-col" aria-label="Mobile navigation">
                {routes.map((route) => (
                  <SheetClose asChild key={route.href}>
                    <Link className="mobile-nav-link" to={route.href}>
                      {route.label}
                    </Link>
                  </SheetClose>
                ))}
              </nav>
              <div className="absolute bottom-10 left-8 right-8 border-t border-white/10 pt-6">
                <p className="text-xs uppercase tracking-[0.16em] text-white/40">
                  New business
                </p>
                <a
                  className="mt-2 inline-block text-sm text-white"
                  href="mailto:gregk2013@gmail.com"
                >
                  gregk2013@gmail.com
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
